import { Stack } from 'expo-router';

import GoBackButton from '@/components/buttons/GoBackButton';
import Title from '@/components/Title';
import PlatformContainer from '@/components/web/PlatformContainer';
import { i18n } from '@/utils/i18n';

export default function StackLayout() {
  return (
    <PlatformContainer contentCustomClassnames="flex">
      <Stack>
        <Stack.Screen
          name="index"
          options={{
            headerTransparent: true,
            headerTitle: '',
            headerLeft: () => <GoBackButton navigateTo={'/'} />,
            headerShown: true,
            headerBackVisible: false
          }}
        />
        <Stack.Screen
          name="preferences"
          options={{
            headerShown: false
          }}
        />
        <Stack.Screen
          name="intro"
          options={{
            headerShown: false
          }}
        />
        <Stack.Screen
          name="startSetup"
          options={{
            headerTitle: () => <Title label={i18n.t('sign_in.nonProfit.intro.start_profile.create_profile')} />,
            headerLeft: () => <GoBackButton />,
            headerShadowVisible: false,
            headerBackVisible: false
          }}
        />
        <Stack.Screen
          name="onBoarding"
          options={{
            headerShown: false
          }}
        />
        <Stack.Screen name="addUpdateDirector" />
        <Stack.Screen name="addUpdatePastor" />
        <Stack.Screen name="addUpdateSalary" />
        <Stack.Screen name="addUpdateProgram" />
        <Stack.Screen name="addUpdateTotalGrantProgram" />
        <Stack.Screen
          name="findNpo"
          options={{
            headerShown: false
          }}
        />
        <Stack.Screen
          name="forgotPassword"
          options={{
            headerBackVisible: false,
            headerTransparent: true,
            title: '',
            headerShadowVisible: false,
            headerLeft: () => <GoBackButton />
          }}
        />
      </Stack>
    </PlatformContainer>
  );
}
